import { CAMPAIGN_CADENCES_TYPE_TABS } from '../../../../../features/campaign-cadences/constants/campaignCadencesTabs';

export function buildTypeTabs(activeTypeTab, onTypeTabChange) {
  return CAMPAIGN_CADENCES_TYPE_TABS.map((tab) => ({
    key: tab.key,
    label: tab.label,
    isActive: tab.key === activeTypeTab,
    onClick: () => onTypeTabChange(tab.key),
  }));
}
